<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >Video KYC </h2>
        </div>
        <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a> 
        </div>
        <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='22'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
            (mouseout)="showpayment(false,'2')" id="23">

            <label for="" class="mt-4" >Video KYC (Know Your Customer) is an
                advanced and
                secure
                verification process used by PayG to board customers remotely. It allows
                customers
                to
                complete their KYC requirements through a video instead of physically
                visiting a
                branch
                or office for in-person verification. The customer is required to present
                and
                verify
                their identity and relevant documents, which are typically government-issued
                identification documents such as Aadhaar, and PAN card. </label>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="24">
            <h2 >
                Benefits of Video KYC
            </h2>
            <label for="" class="mt-3" >Video KYC (Know Your Customer) offers
                several
                benefits
                for
                both
                businesses and customers. Here are some key advantages: </label>
            <h5 class="mt-3" >Convenience </h5>
            <label for="" class="mt-1" >Video KYC provides a convenient and
                flexible way for
                customers to
                complete the KYC process from the comfort of their homes or any location
                with an
                internet connection. </label>

            <h5 class="mt-3" >Time-Efficiency </h5>
            <label for="" class="mt-1" >It significantly reduces the time
                required to
                complete
                the
                KYC
                process compared to traditional methods, where customers may need to visit
                physical
                locations. </label>

            <h5 class="mt-3" >Cost Savings </h5>
            <label for="" class="mt-1" >Businesses can achieve cost savings
                by reducing the
                need
                for
                physical infrastructure, such as brick-and-mortar branches, and optimizing
                the
                KYC
                process. </label>
            <h5 class="mt-3" >Enhanced Security </h5>
            <label for="" class="mt-1" >Video KYC enhances security by
                allowing real-time
                face-to-face
                verification, reducing the risk of identity fraud, and ensuring that the
                person
                undergoing KYC is physically present. </label>

            <h5 class="mt-3" >User Experience </h5>
            <label for="" class="mt-1" >The video KYC process contributes to
                a positive user
                experience,
                as customers can complete the KYC requirements through a more interactive
                and
                user-friendly interface. </label>
            <h5 class="mt-3" >Compliance </h5>
            <label for="" class="mt-1" >Video KYC helps businesses stay
                compliant with
                regulatory
                requirements by ensuring a thorough and documented verification process.
            </label>

            <h5 class="mt-3" >Reduced Paperwork </h5>
            <label for="" class="mt-1" >By digitizing the KYC process, video
                KYC reduces the
                need
                for
                extensive paperwork, contributing to a more environmentally friendly and
                streamlined
                process.
            </label>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
            (mouseout)="showpayment(false,'4')" id="25">
            <h2 >
                The video KYC procedure in PayG consists of the following steps:
            </h2>
            <label for="" class="mt-2" > <b> Step 1:</b> Open the PayG app, navigate to the Video KYC section, and select your preferred language. </label>
            <br> <img src="./assets/kyc 1.png" width="250px" height="800px"
                                         alt="">
            
            <br> <label for="" class="mt-2" > <b> Step 2:</b> Click on the checkbox 'I agree to your Terms and conditions' and initiate the video KYC process by clicking on the "Start Video KYC" option. </label>
            <br> <img src="./assets/kyc 2.png" width="200px" height="400px"
                                         alt="">
            

            <br> <label for="" class="mt-2" > <b> Step 3:</b> Click on “I am
                ready” and say your name
                clearly.Adjust your camera to ensure your face is clearly visible on the screen, then proceed to click on 'Start Video KYC. </label>
            <br> <img src="./assets/kyc 3.png" width="200px" height="400px"
                                         alt="">
            

            <br> <label for="" class="mt-2" > <b> Step 4:</b> Click on “I am ready” and say your name clearly. 
            </label>
            <br> <img src="./assets/kyc 4.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 5.png" width="200px" height="400px"
                                         alt="">

            <br> <label for="" class="mt-2" > <b> Step 5:</b> Click on “I am ready” again and say your company’s name.</label>
            <br> <img src="./assets/kyc 6.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 7.png" width="200px" height="400px"
                                         alt="">
            <br> <label for="" class="mt-2" > <b> Step 6:</b> In the same way show your Aadhar card in the video and read out the Aadhar number loudly in the video.  </label>
            <br> <img src="./assets/kyc 8.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 9.png" width="200px" height="400px"
                                         alt="">

            <br> <label for="" class="mt-2" > <b> Step 7:</b> Display your Pan card clearly in the video frame and read out your Pan Card number. 
               </label>
            <br> <img src="./assets/kyc 10.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 11.png" width="200px" height="400px"
                                         alt="">

            <br> <label for="" class="mt-2" > <b> Step 8:</b> In this step click live pictures of your company’s infrastructure. 
               </label>
            <br> <img src="./assets/kyc 12.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 13.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 14.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 15.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 16.png" width="200px" height="400px"
                                         alt="">
            
            <br> <label for="" class="mt-2" > <b> Step 9:</b> Click on the submit button.
               </label>
            <br> <img src="./assets/kyc 17.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 18.png" width="200px" height="400px"
                                         alt="">

        </div>
    </div>
    
</div>

</div>
<div class="col-md-4  hide-tbl content2   ">
    <div class="card crd p-4">
        <div class="row">
            <div class="col-md-12">
                <h5 >
                    Table of Contents:
                </h5>
            </div>
            <!-- <div class="col-md-12 mt-2">
            <a href="#22"> <div class="row">
                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">
                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        What is a Video KYC? </span>
                </div>
            </div></a
        </div> -->
            <div class="col-md-12 mt-2">
                <a href="#23">
                    <div class="row">
                        <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                alt="">
                            &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                >
                                What is a Video KYC? </span>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-md-12 mt-2">
                <a href="#24">
                    <div class="row">
                        <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                alt="">
                            &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="textHover"
                                [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                >Benefits
                                of
                                Video KYC </span>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-md-12 mt-2">
                <a href="#25">
                    <div class="row">
                        <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                alt="">
                            &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="textHover"
                                [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                >Video KYC
                                Procedure at PayG </span>
                        </div>
                    </div>
                </a>
            </div>


        </div>
    </div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
            <a [routerLink]="['/invoice']">  <button class="btn btn-color" (click)="menues('Invoice')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Invoice
            </button></a>
           
        </div>
        <div class="col-md-4   ">
            <a [routerLink]="['/transaction']"> <button class="btn btn-color" (click)="menues('Transactions')"
                >Transactions
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
           
        </div>
    </div>
</div>
</div>